import { IntegrateAdapter } from "./adapter/integrate";

import { ISupportRepo } from "./irepo";

import { TError } from "../../types/error";

export class SupportUsecase {
  private repo: ISupportRepo;
  private error: (error: TError) => void;

  constructor(repo: ISupportRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async clearCache(): Promise<boolean> {
    try {
      return await this.repo.clearCache();
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchIntegrateFlg(): Promise<boolean> {
    try {
      const data = await this.repo.fetchIntegrateFlg();
      return IntegrateAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async toggleIntegrateFlg(): Promise<boolean> {
    try {
      const data = await this.repo.toggleIntegrateFlg();
      return IntegrateAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }
}
